import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";

import { GenericModal } from "../components/Modal";
import { ContentWrapper } from "../components/Nav";
import { Coupon } from "../components/Listing";
import "./styles/Coupons.scss";

class Coupons extends React.Component {
  state = {
    coupons: this.props.userData.coupons || {},
    viewCouponOpen: false,
    couponClicked: {}
  };

  handleCouponClick = e => {
    if (e.target.className.search("shareWithFriend") !== -1) {
      return;
    }

    const index = e.currentTarget.id.split("_")[1];
    this.setState({
      viewCouponOpen: true,
      couponClicked: this.state.coupons[index]
    });
  };

  render() {
    const { couponClicked } = this.state;

    return (
      <ContentWrapper style={{ backgroundColor: "#F2F6FA" }}>
        <GenericModal
          open={this.state.viewCouponOpen}
          onClose={() => this.setState({ viewCouponOpen: false })}
        >
          <Coupon
            name={couponClicked.Name}
            locations={couponClicked["Locations Available"] || []}
            expires={couponClicked["Expiration Date"]}
          />
        </GenericModal>
        <Container style={{ padding: "30px 5%" }}>
          <h3 className="sectionTitle">Available Coupons</h3>
          <Row>
            {this.state.coupons &&
              this.state.coupons.map((coupon, index) => {
                return (
                  <Col sm={6} key={index} className="minorCol">
                    <Coupon
                      name={coupon.Name}
                      id={`coupon_${index}`}
                      onClick={this.handleCouponClick}
                      locations={coupon["Locations Available"]}
                      expires={coupon["Expiration Date"]}
                      hideOverflow
                    />
                  </Col>
                );
              })}
          </Row>
        </Container>
      </ContentWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Coupons);
